import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { LoadingBoxComponent } from '../../../../../shared/components/loading-box/loading-box.component';
import { ControleEstoqueLoteStatusEnum } from '../../../../../shared/enums/produto/controle-estoque-lote-status.enum';
import { ControleEstoqueSerieStatusEnum } from '../../../../../shared/enums/produto/controle-estoque-serie-status.enum';
import { AlertService, AlertType } from '../../../../../shared/services/alert.service';
import { ControleEstoqueService } from '../../../../../shared/services/apis/produto/controle-estoque.service';
import { ControleEstoqueDetalheLotesRequest } from '../../../../../shared/services/requests/produto/controle-estoque-detalhe-lotes.request';
import { ControleEstoqueDetalheMovimentosRequest } from '../../../../../shared/services/requests/produto/controle-estoque-detalhe-movimentos.request';
import { ControleEstoqueDetalheReservasRequest } from '../../../../../shared/services/requests/produto/controle-estoque-detalhe-reservas.request';
import { ControleEstoqueDetalheSeriesRequest } from '../../../../../shared/services/requests/produto/controle-estoque-detalhe-series.request';
import { ControleEstoqueDetalheLoteStruct } from '../../../../../shared/services/structs/produto/controle-estoque-detalhe-lote.struct';
import { ControleEstoqueDetalheMovimentoStruct } from '../../../../../shared/services/structs/produto/controle-estoque-detalhe-movimento.struct';
import { ControleEstoqueDetalheReservaStruct } from '../../../../../shared/services/structs/produto/controle-estoque-detalhe-reserva.struct';
import { ControleEstoqueDetalheSerieStruct } from '../../../../../shared/services/structs/produto/controle-estoque-detalhe-serie.struct';
import { AbntPipe } from '../../../../../shared/pipes/abnt.pipe';

export type ImpressaoControleEstoqueDetalheAba = 'movimentos' | 'reservas' | 'lotes' | 'series';

export interface ImpressaoControleEstoqueDetalheData {
  abaAtiva: ImpressaoControleEstoqueDetalheAba;
  idProduto: number;
  tituloAba: string;
  descricaoProduto?: string;
  request:
    | ControleEstoqueDetalheMovimentosRequest
    | ControleEstoqueDetalheReservasRequest
    | ControleEstoqueDetalheLotesRequest
    | ControleEstoqueDetalheSeriesRequest;
  colunasMovimentos?: string[];
}

@Component({
  selector: 'app-impressao-controle-estoque-detalhe',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule, MatTableModule, LoadingBoxComponent, AbntPipe],
  templateUrl: './impressao-controle-estoque-detalhe.component.html',
  styleUrls: ['./impressao-controle-estoque-detalhe.component.css'],
})
export class ImpressaoControleEstoqueDetalheComponent implements OnInit {
  private readonly colunasMovimentosImpressao: string[] = [
    'dataHora',
    'operacao',
    'clienteFornecedor',
    'unidade',
    'valorUnitario',
    'movimentado',
  ];

  public isLoading: boolean = false;

  public movimentos: ControleEstoqueDetalheMovimentoStruct[] = [];
  public reservas: ControleEstoqueDetalheReservaStruct[] = [];
  public lotes: ControleEstoqueDetalheLoteStruct[] = [];
  public series: ControleEstoqueDetalheSerieStruct[] = [];

  public displayedColumnsMovimentos: string[] = [
    'dataHora',
    'operacao',
    'clienteFornecedor',
    'unidade',
    'valorUnitario',
    'movimentado',
  ];
  public displayedColumnsReservas: string[] = ['dataHora', 'quantidade', 'origem'];
  public displayedColumnsLotes: string[] = ['dataValidade', 'numeroLote', 'reservado', 'disponivel', 'status'];
  public displayedColumnsSeries: string[] = ['numeroSerie', 'dataEntrada', 'status', 'pedido'];

  constructor(
    public dialogRef: MatDialogRef<ImpressaoControleEstoqueDetalheComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ImpressaoControleEstoqueDetalheData,
    private controleEstoqueService: ControleEstoqueService,
    private alertService: AlertService
  ) {}

  ngOnInit(): void {
    this.configurarColunasMovimentos();
    this.buscarRelatorio();
  }

  public get temDados(): boolean {
    if (this.data.abaAtiva === 'movimentos') return this.movimentos.length > 0;
    if (this.data.abaAtiva === 'reservas') return this.reservas.length > 0;
    if (this.data.abaAtiva === 'lotes') return this.lotes.length > 0;
    return this.series.length > 0;
  }

  public imprimir(): void {
    const conteudoParaImprimir = document.querySelector('.modal-print-container');
    if (!conteudoParaImprimir) return;

    const janelaImpressao = window.open('', '', 'height=700,width=1100');
    if (!janelaImpressao) return;

    const styles = Array.from(document.styleSheets)
      .map(styleSheet => {
        try {
          return Array.from(styleSheet.cssRules)
            .map(rule => rule.cssText)
            .join('');
        } catch {
          return '';
        }
      })
      .join('');

    janelaImpressao.document.write(`
      <html>
        <head>
          <title>Impressão - ${this.data.tituloAba}</title>
          <base href="/">
          <style>
            ${styles}
            html, body {
              height: auto !important;
              min-height: 0 !important;
              overflow: visible !important;
              margin: 20px;
              font-family: Roboto, "Helvetica Neue", sans-serif;
              color: #000;
              background: #fff;
            }
            .no-print { display: none !important; }
            .modal-print-container {
              display: block !important;
              width: 100% !important;
              height: auto !important;
              min-height: 0 !important;
              overflow: visible !important;
              box-shadow: none !important;
              margin: 0 !important;
              padding: 0 !important;
            }
            .mat-mdc-table { background: white !important; }
            .mat-mdc-header-cell { color: black !important; font-weight: bold !important; border-bottom: 2px solid black !important; }
            .mat-mdc-cell { color: black !important; border-bottom: 1px solid #ddd !important; }
          </style>
        </head>
        <body>
          ${conteudoParaImprimir.innerHTML}
        </body>
      </html>
    `);

    janelaImpressao.document.close();
    janelaImpressao.focus();

    setTimeout(() => {
      janelaImpressao.print();
      janelaImpressao.close();
    }, 800);
  }

  public fechar(): void {
    this.dialogRef.close();
  }

  public textoStatusSerie(status: ControleEstoqueSerieStatusEnum): string {
    if (status === ControleEstoqueSerieStatusEnum.Disponivel) return 'Disponível';
    if (status === ControleEstoqueSerieStatusEnum.Reservado) return 'Reservado';
    return 'Baixado';
  }

  public textoStatusLote(status: ControleEstoqueLoteStatusEnum): string {
    if (status === ControleEstoqueLoteStatusEnum.Disponivel) return 'Disponível';
    if (status === ControleEstoqueLoteStatusEnum.ProximoVencimento) return 'Próximo vencimento';
    if (status === ControleEstoqueLoteStatusEnum.Vencido) return 'Vencido';
    return '-';
  }

  private buscarRelatorio(): void {
    this.isLoading = true;

    if (this.data.abaAtiva === 'movimentos') {
      this.controleEstoqueService
        .getPrintMovimentos(this.data.idProduto, this.data.request as ControleEstoqueDetalheMovimentosRequest)
        .subscribe({
          next: res => {
            this.isLoading = false;
            if (res.isError) {
              this.alertService.show('Aviso', res.errorDescription, AlertType.warning);
              this.fechar();
              return;
            }
            this.movimentos = res.list || [];
          },
          error: () => {
            this.isLoading = false;
            this.alertService.show('Erro', 'Erro ao gerar relatório de movimentações', AlertType.error);
            this.fechar();
          },
        });
      return;
    }

    if (this.data.abaAtiva === 'reservas') {
      this.controleEstoqueService
        .getPrintReservas(this.data.idProduto, this.data.request as ControleEstoqueDetalheReservasRequest)
        .subscribe({
          next: res => {
            this.isLoading = false;
            if (res.isError) {
              this.alertService.show('Aviso', res.errorDescription, AlertType.warning);
              this.fechar();
              return;
            }
            this.reservas = res.list || [];
          },
          error: () => {
            this.isLoading = false;
            this.alertService.show('Erro', 'Erro ao gerar relatório de reservas', AlertType.error);
            this.fechar();
          },
        });
      return;
    }

    if (this.data.abaAtiva === 'lotes') {
      this.controleEstoqueService
        .getPrintLotes(this.data.idProduto, this.data.request as ControleEstoqueDetalheLotesRequest)
        .subscribe({
          next: res => {
            this.isLoading = false;
            if (res.isError) {
              this.alertService.show('Aviso', res.errorDescription, AlertType.warning);
              this.fechar();
              return;
            }
            this.lotes = res.list || [];
          },
          error: () => {
            this.isLoading = false;
            this.alertService.show('Erro', 'Erro ao gerar relatório de lotes', AlertType.error);
            this.fechar();
          },
        });
      return;
    }

    this.controleEstoqueService
      .getPrintSeries(this.data.idProduto, this.data.request as ControleEstoqueDetalheSeriesRequest)
      .subscribe({
        next: res => {
          this.isLoading = false;
          if (res.isError) {
            this.alertService.show('Aviso', res.errorDescription, AlertType.warning);
            this.fechar();
            return;
          }
          this.series = res.list || [];
        },
        error: () => {
          this.isLoading = false;
          this.alertService.show('Erro', 'Erro ao gerar relatório de séries', AlertType.error);
          this.fechar();
        },
      });
  }

  private configurarColunasMovimentos(): void {
    this.displayedColumnsMovimentos = [...this.colunasMovimentosImpressao];
  }
}
